module.exports = __webpack_public_path__ + "static/media/play.57fdac4f.svg";